import { render, staticRenderFns } from "./ProcedimentoFormEdit.vue?vue&type=template&id=e42b7130&scoped=true"
import script from "./ProcedimentoFormEdit.vue?vue&type=script&lang=js"
export * from "./ProcedimentoFormEdit.vue?vue&type=script&lang=js"
import style0 from "./ProcedimentoFormEdit.vue?vue&type=style&index=0&id=e42b7130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42b7130",
  null
  
)

export default component.exports